import Cookies from 'js-cookie'

const TokenKey = 'Authorization'
const KqTokenKey = 'KqAuthorization'
const UserId = 'userId'
const KqUserId = 'KquserId'
const Account ='account'
const KqAccount ='Kqaccount'

const auth = {
  //token
  getToken: () => {
    return Cookies.get(TokenKey)
  },

  setToken: (token) => {
    return Cookies.set(TokenKey, token)
  },

  removeToken: () => {
    return Cookies.remove(TokenKey)
  },
  //kqToken
  getKqToken: () => {
    return Cookies.get(KqTokenKey)
  },

  setKqToken: (token) => {
    return Cookies.set(KqTokenKey, token)
  },

  removeKqToken: () => {
    return Cookies.remove(KqTokenKey)
  },
//userId
  getUserId: () => {
    return Cookies.get(UserId)
  },

  setUserId: (userId) => {
    return Cookies.set(UserId, userId)
  },

  removeUserId: () => {
    return Cookies.remove(UserId)
  },
  // kq
  getKqUserId: () => {
    return Cookies.get(KqUserId)
  },

  setKqUserId: (userId) => {
    return Cookies.set(KqUserId, userId)
  },

  removeKqUserId: () => {
    return Cookies.remove(KqUserId)
  },
//登录账号信息
  getAccount: () => {
    return Cookies.get(Account)
  },

  setAccount: (account) => {
    return Cookies.set(Account, account)
  },

  removeAccount: () => {
    return Cookies.remove(Account)
  },
  getKqAccount: () => {
    return Cookies.get(KqAccount)
  },

  setKqAccount: (account) => {
    return Cookies.set(KqAccount, account)
  },

  removeKqAccount: () => {
    return Cookies.remove(KqAccount)
  },
}
export {
  auth,
}
